var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.875s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.875s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.21320343559643,71.21320343559643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.875,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.75s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.75s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.75,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.625s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.625s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.786796564403577,71.21320343559643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.625,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.5s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,50.00000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.5,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.375s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.375s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.78679656440357,28.786796564403577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.375,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.25s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.25s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.99999999999999,20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.25,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "-0.125s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.125s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.21320343559643,28.78679656440357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.125,
    fill: "#013ca6",
    r: 6,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.5 1.5;1 1",
    begin: "0s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2025bb105cce4a771097c5dfba209e83.svg";
export { ForwardRef as ReactComponent };